import { _pejerProvider, defaultPejerState, usePejerBase } from 'pejer/src/stores/pejerData'
import { PejerUser } from './PejerUser'
import { config } from './config'

const pejer = new PejerUser({
  ...defaultPejerState,
  data: {},
})

export const pejerProvider = () => _pejerProvider(pejer as any, config)

export const usePejer = () => {
  const pejer = usePejerBase() as PejerUser
  if (!pejer.config) throw new Error('Pejer config not set')

  return pejer
}

export { config }
